import type { DxfScene } from '@frontend/api';

import type { DxfSceneLoadInput } from './types';

/**
 * Maps the React Query scene fetch into a `DxfSceneLoadInput`.
 *
 * Single place the optional `data` / `isError` / url triad becomes a
 * discriminant — so the session never juggles parallel nulls.
 */
export const resolveDxfSceneLoadInput = ({
  sceneUrl,
  scene,
  isError,
  error,
}: {
  sceneUrl: string | null;
  scene: DxfScene | null | undefined;
  isError: boolean;
  error?: unknown;
}): DxfSceneLoadInput => {
  if (!sceneUrl) {
    return { status: 'idle' };
  }
  if (isError) {
    return { status: 'error', sceneUrl, error };
  }
  if (scene) {
    return { status: 'ready', sceneUrl, scene };
  }
  return { status: 'loading', sceneUrl };
};
